import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  addressLocationB2B,
  bookAMeeting,
  businessConnectivity,
  canadaUSCoverage,
  companyName,
  currentProviderInternetB2B,
  currentProviderMobileB2B,
  emailB2B,
  finalWordB2B,
  firstNameB2B,
  howManyCellPhoneLines,
  internetSpeedB2B,
  internetSpeedB2BB,
  lastNameB2B,
  phoneNumberB2B,
  postalCode,
  sliderDataB2B,
  sliderDataB2BB,
  thanksB2B,
} from './b2b-steps'

export const b2bScenarioA: Scenario = {
  id: 'b2b-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.B2B,
  version: '1',
  milestones: [
    emailB2B.id,
    firstNameB2B.id,
    lastNameB2B.id,
    phoneNumberB2B.id,
    companyName.id,
    postalCode.id,
    businessConnectivity.id,
    finalWordB2B.id,
    bookAMeeting.id,
    thanksB2B.id,
  ],
  steps: [
    emailB2B,
    firstNameB2B,
    lastNameB2B,
    phoneNumberB2B,
    companyName,
    postalCode,
    businessConnectivity,
    currentProviderMobileB2B,
    howManyCellPhoneLines,
    canadaUSCoverage,
    currentProviderInternetB2B,
    internetSpeedB2B,
    sliderDataB2B,
    finalWordB2B,
    bookAMeeting,
    thanksB2B,
  ],
  weight: 0,
}

export const b2bScenarioB: Scenario = {
  id: 'b2b-b',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.B2B,
  version: '1',
  milestones: [
    emailB2B.id,
    firstNameB2B.id,
    lastNameB2B.id,
    phoneNumberB2B.id,
    companyName.id,
    postalCode.id,
    businessConnectivity.id,
    finalWordB2B.id,
    bookAMeeting.id,
    thanksB2B.id,
  ],
  steps: [
    emailB2B,
    firstNameB2B,
    lastNameB2B,
    phoneNumberB2B,
    companyName,
    postalCode,
    businessConnectivity,
    currentProviderMobileB2B,
    howManyCellPhoneLines,
    canadaUSCoverage,
    currentProviderInternetB2B,
    internetSpeedB2BB,
    sliderDataB2BB,
    addressLocationB2B,
    finalWordB2B,
    bookAMeeting,
    thanksB2B,
  ],
  weight: 1,
}
